import React from 'react';
import { Col } from 'react-bootstrap';

const style = {
  color: 'rgb(51, 51, 51)',
  fontSize: '18px',
  fill: 'rgb(51, 51, 51)',
  textAlign: 'center',
  display: 'block',
  borderBottom: '1px solid #ddd',
  padding: '7px',
  fontFamily:
    '-apple-system,BlinkMacSystemFont,Roboto,Oxygen,Ubuntu,sans-serif !important',
};

const CustomWidget = ({ id, children, size, title }) => (
  <Col lg={size}>
    <Col lg={12} id={id} className="box-border">
      {title !== undefined && <div style={style}>{title}</div>}
      {children}
    </Col>
  </Col>
);

export default CustomWidget;
